import React, { useState } from "react";

import { Button } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import InfoIcon from "./InfoIcon";

// scontrino wrapper -----------------------------------
const ScontrinoRowWrapper = ({ children, title, tooltipText }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <div className="border-b border-gray-700 w-full px-4 pb-4 mt-2 dark:bg-gray-700">
      <div className="flex flex-row items-center">
        {title !== undefined && (
          <h3 className="font-semibold text-xl">{title}</h3>
        )}
        {tooltipText !== undefined && (
          <Tooltip
            title={tooltipText}
            arrow
            style={{ position: "relative", zIndex: "0" }}
            open={showTooltip}
            onOpen={() => setShowTooltip(true)}
            onClose={() => setShowTooltip(false)}
          >
            <Button
              variant="outlined"
              style={{ border: "none", overflow: "visible" }}
              onClick={() => setShowTooltip(!showTooltip)}
            >
              <InfoIcon className="dark:fill-[white]" />
            </Button>
          </Tooltip>
        )}
      </div>
      {children}
    </div>
  );
};

export default ScontrinoRowWrapper;
